<div class="runtime-settings__scroll">
  <div class="runtime-settings__groups">
    <fieldset [disabled]="viewer.runtimeSettingsBusy">
      <legend>Visual quality</legend>
      <label class="runtime-settings__field" for="qualityProfile">
        <span>Quality profile</span>
        <select
          id="qualityProfile"
          [value]="viewer.visualQualitySettingsDraft.profile"
          (change)="viewer.onVisualQualityProfileChanged($event)"
        >
          <option
            *ngFor="let profile of viewer.visualQualityProfiles"
            [value]="profile.value"
            [selected]="profile.value === viewer.visualQualitySettingsDraft.profile"
            [title]="profile.description"
          >
            {{ profile.label }}
          </option>
        </select>
      </label>
      <label class="runtime-settings__field" for="qualityAntiAliasing">
        <span>Anti-aliasing</span>
        <select
          id="qualityAntiAliasing"
          [value]="viewer.visualQualitySettingsDraft.antiAliasing"
          (change)="viewer.onVisualQualityAntiAliasingChanged($event)"
        >
          <option
            *ngFor="let antiAliasing of viewer.visualQualityAntiAliasingOptions"
            [value]="antiAliasing.value"
            [selected]="antiAliasing.value === viewer.visualQualitySettingsDraft.antiAliasing"
          >
            {{ antiAliasing.label }}
          </option>
        </select>
      </label>
      <label class="runtime-settings__field" for="qualityShadingMode">
        <span>Mesh shading</span>
        <select
          id="qualityShadingMode"
          [value]="viewer.visualQualitySettingsDraft.shadingMode"
          (change)="viewer.onVisualQualityShadingModeChanged($event)"
        >
          <option value="unlit">Flat / unlit</option>
          <option value="diffuse">Diffuse normals</option>
        </select>
      </label>
      <label class="runtime-settings__field" for="qualitySpecularEnabled">
        <span>Specular highlights</span>
        <input
          id="qualitySpecularEnabled"
          type="checkbox"
          [checked]="viewer.visualQualitySettingsDraft.specularEnabled"
          (change)="viewer.onVisualQualityToggleChanged('specularEnabled', $event)"
        />
      </label>
      <label class="runtime-settings__field" for="qualityFresnelEnabled">
        <span>Fresnel silhouette</span>
        <input
          id="qualityFresnelEnabled"
          type="checkbox"
          [checked]="viewer.visualQualitySettingsDraft.fresnelEnabled"
          (change)="viewer.onVisualQualityToggleChanged('fresnelEnabled', $event)"
        />
      </label>
      <ng-container *ngIf="viewer.visualQualityCadEffectsDraftActive">
        <label class="runtime-settings__field" for="cadSsaoEnabled">
          <span>Ambient occlusion</span>
          <input
            id="cadSsaoEnabled"
            type="checkbox"
            [checked]="viewer.visualQualitySettingsDraft.cad.ssaoEnabled"
            (change)="viewer.onCadToggleChanged('ssaoEnabled', $event)"
          />
        </label>
        <label class="runtime-settings__field" for="cadEdgesEnabled">
          <span>Crease and silhouette edges</span>
          <input
            id="cadEdgesEnabled"
            type="checkbox"
            [checked]="viewer.visualQualitySettingsDraft.cad.edgesEnabled"
            (change)="viewer.onCadToggleChanged('edgesEnabled', $event)"
          />
        </label>
        <label class="runtime-settings__field" for="cadTonemapEnabled">
          <span>Filmic tonemapping</span>
          <input
            id="cadTonemapEnabled"
            type="checkbox"
            [checked]="viewer.visualQualitySettingsDraft.cad.tonemapEnabled"
            (change)="viewer.onCadToggleChanged('tonemapEnabled', $event)"
          />
        </label>
        <label class="runtime-settings__field" for="cadGradientBackground">
          <span>Gradient background</span>
          <input
            id="cadGradientBackground"
            type="checkbox"
            [checked]="viewer.visualQualitySettingsDraft.cad.gradientBackground"
            (change)="viewer.onCadToggleChanged('gradientBackground', $event)"
          />
        </label>
        <label class="runtime-settings__field" for="cadVignette">
          <span>Backdrop vignette</span>
          <input
            id="cadVignette"
            type="checkbox"
            [checked]="viewer.visualQualitySettingsDraft.cad.vignette"
            (change)="viewer.onCadToggleChanged('vignette', $event)"
          />
        </label>
        <label class="runtime-settings__field" for="cadSsaoIntensity" title="Ambient occlusion strength.">
          <span>Occlusion intensity</span>
          <input
            id="cadSsaoIntensity"
            type="number"
            min="0"
            max="2"
            step="0.1"
            [value]="viewer.visualQualitySettingsDraft.cad.ssaoIntensity"
            (input)="viewer.onCadNumberChanged('ssaoIntensity', $event)"
          />
        </label>
        <label
          class="runtime-settings__field"
          for="cadSsaoRadius"
          title="Occlusion radius as a fraction of the viewport height."
        >
          <span>Occlusion radius</span>
          <input
            id="cadSsaoRadius"
            type="number"
            min="0.005"
            max="0.08"
            step="0.005"
            [value]="viewer.visualQualitySettingsDraft.cad.ssaoRadius"
            (input)="viewer.onCadNumberChanged('ssaoRadius', $event)"
          />
        </label>
        <label class="runtime-settings__field" for="cadEdgeIntensity" title="Edge darkness.">
          <span>Edge intensity</span>
          <input
            id="cadEdgeIntensity"
            type="number"
            min="0"
            max="1"
            step="0.05"
            [value]="viewer.visualQualitySettingsDraft.cad.edgeIntensity"
            (input)="viewer.onCadNumberChanged('edgeIntensity', $event)"
          />
        </label>
        <label class="runtime-settings__field" for="cadEdgeWidth" title="Edge thickness in pixels: 1 or 2.">
          <span>Edge width</span>
          <input
            id="cadEdgeWidth"
            type="number"
            min="1"
            max="2"
            step="1"
            [value]="viewer.visualQualitySettingsDraft.cad.edgeWidth"
            (input)="viewer.onCadNumberChanged('edgeWidth', $event)"
          />
        </label>
        <label
          class="runtime-settings__field"
          for="cadTonemapStrength"
          title="Share of the filmic curve blended over the scene color."
        >
          <span>Tonemap strength</span>
          <input
            id="cadTonemapStrength"
            type="number"
            min="0"
            max="1"
            step="0.05"
            [value]="viewer.visualQualitySettingsDraft.cad.tonemapStrength"
            (input)="viewer.onCadNumberChanged('tonemapStrength', $event)"
          />
        </label>
        <label
          class="runtime-settings__field"
          for="cadSaturation"
          title="Color saturation; 0 is grey, 1 keeps the model colors."
        >
          <span>Saturation</span>
          <input
            id="cadSaturation"
            type="number"
            min="0"
            max="2"
            step="0.05"
            [value]="viewer.visualQualitySettingsDraft.cad.saturation"
            (input)="viewer.onCadNumberChanged('saturation', $event)"
          />
        </label>
        <label
          class="runtime-settings__field"
          for="cadWarmth"
          title="White balance shift; negative is cooler, positive is warmer."
        >
          <span>Warmth</span>
          <input
            id="cadWarmth"
            type="number"
            min="-1"
            max="1"
            step="0.05"
            [value]="viewer.visualQualitySettingsDraft.cad.warmth"
            (input)="viewer.onCadNumberChanged('warmth', $event)"
          />
        </label>
        <label
          class="runtime-settings__field"
          for="cadKeyLight"
          title="Camera-relative key light from the upper left that shades surfaces facing away from it."
        >
          <span>Key light</span>
          <input
            id="cadKeyLight"
            type="number"
            min="0"
            max="1"
            step="0.05"
            [value]="viewer.visualQualitySettingsDraft.cad.keyLight"
            (input)="viewer.onCadNumberChanged('keyLight', $event)"
          />
        </label>
        <label
          class="runtime-settings__field"
          for="cadSharpen"
          title="Unsharp-mask amount, applied once the camera stops."
        >
          <span>Sharpen</span>
          <input
            id="cadSharpen"
            type="number"
            min="0"
            max="1"
            step="0.05"
            [value]="viewer.visualQualitySettingsDraft.cad.sharpen"
            (input)="viewer.onCadNumberChanged('sharpen', $event)"
          />
        </label>
      </ng-container>
      <label class="runtime-settings__field" for="qualityAmbientIntensity" title="Ambient light multiplier.">
        <span>Ambient intensity</span>
        <input
          id="qualityAmbientIntensity"
          type="number"
          min="0"
          max="2"
          step="0.05"
          [value]="viewer.visualQualitySettingsDraft.ambientIntensity"
          (input)="viewer.onVisualQualityNumberChanged('ambientIntensity', $event)"
        />
      </label>
      <label class="runtime-settings__field" for="qualityDirectionalIntensity" title="Directional light multiplier.">
        <span>Directional intensity</span>
        <input
          id="qualityDirectionalIntensity"
          type="number"
          min="0"
          max="3"
          step="0.05"
          [value]="viewer.visualQualitySettingsDraft.directionalIntensity"
          (input)="viewer.onVisualQualityNumberChanged('directionalIntensity', $event)"
        />
      </label>
      <label class="runtime-settings__field" for="qualitySpecularIntensity" title="Specular highlight strength.">
        <span>Specular intensity</span>
        <input
          id="qualitySpecularIntensity"
          type="number"
          min="0"
          max="1"
          step="0.05"
          [value]="viewer.visualQualitySettingsDraft.specularIntensity"
          (input)="viewer.onVisualQualityNumberChanged('specularIntensity', $event)"
        />
      </label>
      <label class="runtime-settings__field" for="qualityFresnelIntensity" title="Fresnel silhouette strength.">
        <span>Fresnel intensity</span>
        <input
          id="qualityFresnelIntensity"
          type="number"
          min="0"
          max="1"
          step="0.05"
          [value]="viewer.visualQualitySettingsDraft.fresnelIntensity"
          (input)="viewer.onVisualQualityNumberChanged('fresnelIntensity', $event)"
        />
      </label>
      <label class="runtime-settings__field" for="qualityExposure" title="Scene exposure in stops.">
        <span>Exposure</span>
        <input
          id="qualityExposure"
          type="number"
          min="-1"
          max="1"
          step="0.01"
          [value]="viewer.visualQualitySettingsDraft.exposure"
          (input)="viewer.onVisualQualityNumberChanged('exposure', $event)"
        />
      </label>
      <label class="runtime-settings__field" for="qualityContrast" title="Scene contrast multiplier.">
        <span>Contrast</span>
        <input
          id="qualityContrast"
          type="number"
          min="0.5"
          max="1.5"
          step="0.01"
          [value]="viewer.visualQualitySettingsDraft.contrast"
          (input)="viewer.onVisualQualityNumberChanged('contrast', $event)"
        />
      </label>
    </fieldset>
  </div>
  <div *ngIf="viewer.runtimeSettingsError" class="ingest-panel__error" role="alert">
    {{ viewer.runtimeSettingsError }}
  </div>
</div>
<div class="viewer-panel__actions">
  <button
    type="button"
    [disabled]="viewer.runtimeSettingsBusy || viewer.runtimeSettingsError !== null"
    (click)="viewer.applyRuntimeSettingsNow()"
  >
    Apply
  </button>
  <button type="button" [disabled]="viewer.runtimeSettingsBusy" (click)="viewer.resetRuntimeSettingsDraft()">
    Reset to Defaults
  </button>
  <button
    type="button"
    *ngIf="viewer.selectedSceneId !== null"
    [disabled]="viewer.runtimeSettingsBusy"
    (click)="viewer.copyViewerUrlToClipboard()"
  >
    Copy URL with camera
  </button>
  <ng-container *ngIf="viewer.settingsApplyCountdown !== null; else settingsStatus">
    <span role="status" class="viewer-panel__apply-countdown"
      >Changes will be applied in {{ viewer.settingsApplyCountdown }} seconds</span
    >
    <button type="button" (click)="viewer.cancelPendingSettings()">Cancel</button>
  </ng-container>
  <ng-template #settingsStatus>
    <span role="status">{{
      viewer.runtimeSettingsBusy ? 'Loading scene...' : viewer.settingsApplyPending ? 'Applying changes...' : viewer.runtimeSettingsMessage
    }}</span>
  </ng-template>
</div>
